<template>
  <!-------------------- START - Mobile Menu -------------------->
  <div class="menu-mobile menu-activated-on-click color-scheme-dark">
    <div class="mm-logo-buttons-w">
      <a class="mm-logo" href="/">
        <img src="/logo.png" alt />
        <span>Miniso Cloud</span>
      </a>
      <div class="mm-buttons">
        <div class="content-panel-open">
          <div class="os-icon os-icon-grid-circles"></div>
        </div>
        <div class="mobile-menu-trigger" @click="toggleMenu">
          <div class="os-icon os-icon-hamburger-menu-1"></div>
        </div>
      </div>
    </div>
    <div class="menu-and-user">
      <div class="logged-user-w">
        <div class="avatar-w">
          <img alt v-bind:src="user.image" />
        </div>
        <div class="logged-user-info-w">
          <div class="logged-user-name" v-html="user.name"></div>
          <div class="logged-user-role" v-html="user.email"></div>
        </div>
      </div>
      <!-------------------- START - Mobile Menu List -------------------->
      <ul class="main-menu">
        <li>
        <router-link :to="'/'">
          <div class="icon-w">
            <div :class="'os-icon os-icon-layout'"></div>
          </div>
          <span>Dashboard</span>
        </router-link>
      </li>
        <li
          class="has-sub-menu"
          v-bind:key="currentMenu.name"
          v-for="currentMenu in modules"
        >
          <a href="/">
            <div class="icon-w">
              <div :class="currentMenu.icon"></div>
            </div>
            <span v-html="currentMenu.description"></span>
          </a>
          <ul class="sub-menu">
            <li
              v-bind:key="currentSubItem.name"
              v-for="currentSubItem in currentMenu.items"
            >
              <router-link
                :to="currentSubItem.to"
                v-html="currentSubItem.description"
              >
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="main-menu">
        <li>
          <a href="#" @click="logout">
            <div class="icon-w">
              <div :class="'os-icon os-icon-signs-11'"></div>
            </div>
            <span>Logout</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-------------------- END - Mobile Menu -------------------->
</template>

<script>
import SideMenuUlComponent from "@/layouts/globals/SideMenuUlComponent.vue";
export default {
  components: {
    SideMenuUlComponent,
  },
  data() {
    return {
      user: {
        name: "",
        image: "",
        email: "",
      },
    };
  },
  props: {},
  watch: {},
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      return this.$store.getters.modules;
    },
  },
  created() {
    this.user.name = localStorage.getItem("name");
    this.user.email = localStorage.getItem("email");
    this.user.image = "http://localhost:8000" + localStorage.getItem("image");
  },
  mounted() {},
  methods: {
    logout: function () {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("image");
      localStorage.removeItem("tipo_usuario");
      localStorage.removeItem("ocultar_checklist_info");
      this.$store.commit("SET_LAYOUT", "clean-layout");
      document.location.href = "/";
    },
    toggleMenu() {
      $(".menu-mobile .menu-and-user").slideToggle(200, "swing");
    },
  },
};
</script>
